(function () {
  if (window.__variantSwatchesInit) return;
  window.__variantSwatchesInit = true;

  var CARD_SELECTOR = '.product-item, [data-product-item], .card';

  function withVariant(url, id) {
    if (!url || url.indexOf('/products/') === -1) return url;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('variant', id);
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function swapImage(card, swatch) {
    var src = swatch.dataset.image;
    if (!src) return;
    var imgs = card.querySelectorAll('img');
    var img = null;
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('[data-variant-swatches]')) { img = imgs[i]; break; }
    }
    if (!img) return;
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (s) { s.remove(); });
    if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
    img.src = src;
    img.loading = 'eager';
  }

  function selectSwatch(swatch) {
    var wrap = swatch.closest('[data-variant-swatches]');
    if (!wrap) return;
    var card = wrap.closest(CARD_SELECTOR) || wrap.parentElement;
    var id = swatch.dataset.variantId;
    var available = swatch.dataset.available === 'true';

    // 1. Active state
    wrap.querySelectorAll('[data-swatch]').forEach(function (b) {
      var on = b === swatch;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.setAttribute('href', withVariant(a.getAttribute('href'), id));
    });
    card.querySelectorAll('[data-product-url], [data-url], [data-href]').forEach(function (el) {
      ['productUrl', 'url', 'href'].forEach(function (k) {
        if (el.dataset[k]) el.dataset[k] = withVariant(el.dataset[k], id);
      });
    });

    // 3. Quick buy / Buy now forms variant id
    card.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
      input.value = id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    card.querySelectorAll('[data-variant-id]:not([data-swatch])').forEach(function (el) {
      el.dataset.variantId = id;
    });

    // 4. Sold out variant add-to-cart disable
    card.querySelectorAll('form[action*="/cart/add"] [type="submit"]').forEach(function (btn) {
      btn.disabled = !available;
    });

    // 5. Card image change
    if (wrap.dataset.swapImage !== 'false') swapImage(card, swatch);

    card.dispatchEvent(new CustomEvent('variant-swatch:change', {
      bubbles: true,
      detail: { variantId: id, available: available }
    }));
  }

  // Event delegation: 
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    selectSwatch(swatch);
  }, true);
})();
